const normalizeSrc = (src) => {
  return src.startsWith("/") ? src.slice(1) : src;
};

export default function cloudflareLoader({ src, width, quality }) {
  const params = new URLSearchParams();
  params.set("width", width);
  if (quality) {
    params.set("quality", quality);
  }

  return `/_images/${normalizeSrc(src)}?${params.toString()}`;
  //return `https://images.fundra.app/transform/${normalizeSrc(src)}?${params.toString()}`;
}
